// hooks/useCharts.tsx

import { useState, useCallback, useMemo, Fragment } from "react";
import { Report } from "../interfaces/intakes.reports";
import { PDFDonutDefects } from "../components/pdf/PDFDonutDefects";
import { PDFDonutCat } from "../components/pdf/PDFDonutCat";

export const useCharts = (data: Report | null) => {
    const [charts, setCharts] = useState<Record<string, string[]>>({});

    const onChartReady = useCallback(
        (id: string, index: number, img: string) => {
            setCharts(prev => {
                const existing = prev[id] || [];
                const next = [...existing];
                next[index] = img;

                return {
                    ...prev,
                    [id]: next,
                };
            });
        },
        []
    );

    // render donuts ocultos
    const DonutsRenderer = useMemo(() => {
        if (!data) return null;

        return (
            <>
                {data.pallets.map(p => (
                    p.pallgrow?.data.length > 0 ? (
                        <Fragment key={p.pid}>
                            <PDFDonutDefects
                                key={`${p.pid}-0`}
                                palletId={p.pid}
                                pallgrow={p.pallgrow}
                                chartIndex={0}
                                onReady={onChartReady}
                            />
                            <PDFDonutCat
                                key={`${p.pid}-1`}
                                palletId={p.pid}
                                pallgrow={p.pallgrow}
                                grade={p.grade}
                                chartIndex={1}
                                onReady={onChartReady}
                            />
                        </Fragment>
                    ) : null
                ))}
            </>
        );
    }, [data, onChartReady]);

    // saber cuándo terminó todo
    const ready = useMemo(() => {
        if (!data) return false;

        return data.pallets.every(p =>
            !p.pallgrow?.data.length || charts[p.pid]?.length === 2
        );
    }, [charts, data]);

    return {
        charts,
        ready,
        DonutsRenderer,
    };
};
